import { useSelector } from 'react-redux'
import { Range } from '../../../types/interfaces'
import classes from './DateFilter.module.sass'
import { format } from 'date-fns'
import { selectDarkTheme } from '../../../../store/slices/settingsSlice'

type Props = {
  onChange: (value: string, first?: boolean) => void
  range: Range
  datesValid?: boolean
}

const DateFilter = ({ onChange, range, datesValid }: Props) => {
  const dark = useSelector(selectDarkTheme)

  return (
    <div className={classes.Container}>
      <div className={classes.Group}>
        <input
          onChange={(e) => onChange(e.target.value, true)}
          value={format(range.from, "yyyy-MM-dd'T'HH:mm")}
          className={dark ? classes.InputDark : classes.Input}
          type="datetime-local"
        />
      </div>
      <div className={classes.Group}>
        <input
          onChange={(e) => onChange(e.target.value)}
          value={format(range.to, "yyyy-MM-dd'T'HH:mm")}
          className={dark ? classes.InputDark : classes.Input}
          type="datetime-local"
        />
      </div>
    </div>
  )
}

export default DateFilter
